module.exports = __webpack_public_path__ + "img/flow3.6c681d05.png";